import { Youtube, getEmbedUrlFromYoutubeUrl } from '@tiptap/extension-youtube'
import { NodeViewWrapper, ReactNodeViewRenderer, type NodeViewProps } from '@tiptap/react'
import { cn } from '@/lib/utils'
import { MediaControls } from './MediaControls'
import { alignAttribute, alignJustifyClass, type MediaAlign } from './mediaAlign'

// Youtube ships no NodeView, so embeds had no in-editor controls. This view
// renders the embed (playable) with the shared hover controls for alignment
// and delete — no click-shield, so the video plays in the editor. Storage is
// unchanged — the extension's own renderHTML still produces the stored
// <div data-youtube-video><iframe>.
function VideoView({ node, selected, deleteNode, updateAttributes }: NodeViewProps) {
  const embed = getEmbedUrlFromYoutubeUrl({ url: node.attrs.src ?? '', nocookie: true })

  return (
    <NodeViewWrapper className={cn('group relative my-3 flex', alignJustifyClass(node.attrs.align))}>
      <div className={cn('relative w-full max-w-2xl overflow-hidden rounded-md', selected && 'ring-2 ring-primary/70')}>
        <div className="relative aspect-video w-full bg-black">
          {embed && (
            <iframe
              src={embed}
              className="absolute inset-0 h-full w-full"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              title="Embedded video"
            />
          )}
        </div>
        <MediaControls
          align={node.attrs.align}
          onAlign={(align: MediaAlign) => updateAttributes({ align })}
          onDelete={deleteNode}
          deleteLabel="Remove video"
        />
      </div>
    </NodeViewWrapper>
  )
}

// Youtube with an editor NodeView + alignment; renderHTML (storage) inherited.
export const ArticleVideo = Youtube.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      ...alignAttribute,
    }
  },

  addNodeView() {
    return ReactNodeViewRenderer(VideoView)
  },
})
